export class BritishColumbiaHealthCardNumberValidator {
    private readonly multipliers = [0, 2, 4, 8, 5, 10, 9, 7, 3, 1];
    private readonly moduloValue = 11;

    public isValid(cardNumber: string) {
        if (!/^\d{10}/.test(cardNumber) && cardNumber[0] !== "9")
            return false;

        const checksum = cardNumber
            .split('')
            .map((p, i) => Number(p) * this.multipliers[i])
            .reduce((partialSum, currentNum) => partialSum += currentNum);

        return checksum % this.moduloValue === 0;
    }
}


// WEBPACK FOOTER //
// ./src/services/Validator/HealthCard/BritishColumbiaHealthCardNumberValidator.ts